import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { PUBLISH_PERIOD_MAP_VALUE_TO_LABEL } from './constants';
import { EPublishPeriod } from '../../../../api-models/common/json_query';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'publishPeriod' as const;

export const publishPeriodTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const publishPeriod = getTermValue('publish_period')(jsonQuery);

    if (publishPeriod === null || publishPeriod === EPublishPeriod.Any) {
      return null;
    }

    const label = `Опубликовано: ${PUBLISH_PERIOD_MAP_VALUE_TO_LABEL[publishPeriod]}`;

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['publish_period'])(jsonQuery),
};
